<div (click)="navigateToDetail()" class="search-result-card" [class.small-mode]="isSmallMode">
  @if (project) {
    <div class="flex gap-100" style="align-items: center;">
      <app-st-icon name="folder_copy" [color]="'#8E4EC6'"></app-st-icon>
      <p class="text-label-14 text-dark text-nowrap" [innerHTML]="highlightMatch(project.name)"></p>
    </div>
  }
  @if (service) {
    <div class="flex gap-100">
      <app-st-icon *ngIf="service" [avatar]="true" class="flex-center"
                   [color]="'#666666'"
                   [name]="globalValuesService.getServiceType(service.typeId || 0)?.icon || 'close'"></app-st-icon>

      <div class="flex flex-column gap-100" style="flex-grow: 1; min-width: 0;">
        <span class="text-label-10 text-nowrap">{{service.project?.name || '-'}}</span>
        <span class="text-label-14 text-dark text-nowrap" [innerHTML]="highlightMatch(service.name)"></span>
      </div>

    </div>
  }
  @if (serviceOrder) {
    <div class="flex-center-between">
      <div class="flex flex-column gap-075" style="max-width: 75%;">
        <span class="text-label-10 text-nowrap">{{serviceOrder.service?.project?.name || '-'}} / {{serviceOrder.service?.name || '-'}} / {{serviceOrder.reference || '-'}}</span>
        <div *ngIf="selectedProperty" class="flex gap-075">
          <span class="text-label-14">{{selectedProperty.label}}:</span>
          <span class="text-label-14 text-dark text-nowrap" [innerHTML]="highlightMatch(deepGet(this.serviceOrder, this.selectedProperty!.path)?.toString())"></span>
        </div>
      </div>

      <div class="flex gap-100 action-btns-container">
        <button (click)="navigateToSO(false)" nz-button
                [nzType]="(isSmallMode || (screenService.isMobile$ | async)) ? 'default' : 'text'"
                [nzShape]="(isSmallMode || (screenService.isMobile$ | async)) ? 'circle' : 'round'" nzSize="default" style="padding-top: 4px">
          <app-st-icon [class.prefix]="!isSmallMode && !(screenService.isMobile$ | async)" [color]="'#8E4EC6'" name="folder_copy" ></app-st-icon>
          <span *ngIf="!isSmallMode && !(screenService.isMobile$ | async)" class="text-label-14 text-dark text-semibold">Ver en proyectos</span>
        </button>

        <button (click)="navigateToSO(true)" nz-button
                [nzType]="(isSmallMode || (screenService.isMobile$ | async)) ? 'default' : 'text'"
                [nzShape]="(isSmallMode || (screenService.isMobile$ | async)) ? 'circle' : 'round'" nzSize="default">
          <app-st-icon [class.prefix]="!isSmallMode && !(screenService.isMobile$ | async)" [color]="'#0072F5'" name="monitoring" ></app-st-icon>
          <span *ngIf="!isSmallMode && !(screenService.isMobile$ | async)" class="text-label-14 text-dark text-semibold">Ver en administración</span>
        </button>
      </div>
    </div>
  }
</div>
